import {renderNode} from "../renderNode";
import type {
    ChecklistElements,
    ChecklistObjects,
    RenderableDocument,
} from "../types";
import type {ReactNode} from "react";

export const renderElement = (
    elementId: string,
    elements: ChecklistElements,
    objects: ChecklistObjects,
): ReactNode => {
    if (!elements[elementId]) return null;

    const doc = {
        elements,
        objects,
        elementdata: {},
        root: [{id: elementId}],
        topicId: "",
        id: "",
        resourceTypeId: "",
        segmentId: "",
        topictypeId: "",
        name: "",
    } as unknown as RenderableDocument;

    return renderNode(doc, elementId, elementId);
};
